import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  process_id: null,
  process: "",
  operation_id: null,
  operation_name: "",
  previous_operation_id: null,
  selected_standard_block: null,
  selected_operation_type: null,
};
const processConfigSlice = createSlice({
  name: "processConfig",
  initialState: {
    process_id: null,
    process: "",
    operation_id: null,
    previous_operation_id: null,
    selected_standard_block: null,
    selected_operation_type: null,
  },
  reducers: {
    setProcessId: (state, action) => {
      state.process_id = action.payload;
    },
    setProcess: (state, action) => {
      state.process = action.payload;
    },
    setOperationId: (state, action) => {
      state.operation_id = action.payload;
    },
    setPrevOperationId: (state, action) => {
      state.previous_operation_id = action.payload;
    },
    setOperationName: (state, action) => {
      state.operation_name = action.payload;
    },
    setIsMiddleOp: (state, action) => {
      state.is_add_middle = action.payload;
    },
    setSelectedOperationType: (state, action) => {
      state.selected_operation_type = action.payload;
    },
    setSelectedStandardBlock: (state, action) => {
      state.selected_standard_block = action.payload;
    },
    setProcessConfig: (state, action) => {
      const {
        process_id,
        process,
        previous_operation_id,
        operation_id,
        is_add_middle,
        selected_standard_block,
        selected_operation_type,
      } = action.payload;
      if (process_id !== undefined) state.process_id = process_id;
      if (process !== undefined) state.process = process;
      if (previous_operation_id !== undefined)
        state.previous_operation_id = previous_operation_id;
      if (operation_id !== undefined) state.operation_id = operation_id;
      if (selected_standard_block !== undefined)
        state.selected_standard_block = selected_standard_block;
      if (selected_operation_type !== undefined)
        state.selected_operation_type = selected_operation_type;
      if (is_add_middle !== undefined) state.is_add_middle = is_add_middle;
    },
    resetProcessConfig: () => initialState,
  },
});

export const {
  setProcessId,
  setOperationId,
  setProcessConfig,
  setPrevOperationId,
  setOperationName,
  setIsMiddleOp,
  resetProcessConfig,
  setSelectedStandardBlock,
  setSelectedOperationType,
} = processConfigSlice.actions;
export default processConfigSlice.reducer;
